export const appVersion = {
  version: 'v26.07.09',
  deploy: '-dev.6',
};
